var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ content: _vm.$isMobileDevice }},[_c('common-block',{attrs:{"title":_vm.articleDetail.title,"content":_vm.articleDetail.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }